module.exports = __webpack_public_path__ + "static/media/i-log-out-black.0c74253a.svg";